﻿<template>
    <q-input
        ref="innerInput" class="qe"
        @keydown.enter.prevent="focusNextCounter += 1" />
</template>

<script setup lang="ts">
import { inject, ref } from "vue"

const innerInput = ref()

const focusNextCounter = inject( 'focusNextCounter' )

const focus = () => {
    innerInput.value.focus()
}

defineExpose( { focus } )
</script>
